import Vue from 'vue'
import Router from 'vue-router'

import Find from './view/find'
import Mine from './view/mine'

import privilege from './routes/privilege'
import refund from './routes/refund'
import protocol from './routes/protocol'
import api from './routes/api'
import landing from './routes/landing'
import h5Credit from './routes/h5Credit'
import middle from './routes/middle'
import modifyUserInfo from './routes/modifyUserInfo'
import bankCard from './routes/bankcard'
import actives from './routes/actives'
import vips from './routes/vips'
import appSE from './routes/appSE'
import msg from './routes/msg'
import coupon from './routes/coupon'
import quickRepay from './routes/quickRepay'
import feedback from './routes/feedback'

import unionLogin from '@/assets/union-login'
import { getKey, isTMDMiniprogram } from './assets/utils'
import wx from 'weixin-webview-jssdk'
import store from './store'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const Repayment = () => import('./view/repayment')
const Strategy = () => import('./view/user/strategy.vue')
const Question = () => import('./view/user/question.vue')
const Login = () => import('./view/user/login.vue')
const LoginValidate = () => import('./view/user/login-validate.vue')

// 借款历史
const LoanHistory = () => import('./view/repayment/history.vue')

const RepaymentDetail = () => import('./view/repayment/detail')
const RepaymentResult = () => import('./view/repayment/result')
const TmdRepayment = () => import('./view/repayment/tmd-repay.vue') // 天美贷我要还款
const TmdOverdueRepayment = () => import('./view/repayment/overdue-repay.vue') // 天美贷逾期还款
const RepaymentConfirm = () => import('./view/repayment/confirm.vue') // 还款确认页面
const TmdRepaymentConfirm = () => import('./view/repayment/tmd-confirm.vue') // 天美贷还款确认页面
const RelateProtocol = () => import('./view/protocol')
const LoginProtocol = () => import('./view/protocol/login')
const LoanContactProtocol = () => import('./view/protocol/loan-contract.vue') // 借款合同
const InstructionLoanProtocol = () => import('./view/protocol/loan-instruction.vue') // 借款须知合同
const PersonalAuthorizationInfo = () => import('./view/protocol/authorization.vue') // 个人授权协议
const EntrustProtocol = () => import('./view/protocol/entrust.vue') // 委托扣款协议
const PrivacyProtocol = () => import('./view/protocol/privacy.vue')
const PdfProtocol = () => import('./view/protocol/pdf')
const UpdateProtocol = () => import('./view/protocol/update')
const About = () => import('./view/mine/about')
const Aboutqb = () => import('./view/mine/aboutqb')

const ProtoclLoginQB = () => import('./view/mine/login-protocol-qb.vue')
const ProtoclPrivacyQB = () => import('./view/mine/privacy-protocol-qb.vue')
const AuthenticationBase = () => import('./view/authentication/base')
const AuthenticationId = () => import('./view/authentication/id')
const AuthenticationIdGuide = () => import('./view/authentication/id-guide')
const AuthenticationUpGuide = () => import('./view/authentication/up-card-guide')
const AuthenticationResult = () => import('./view/authentication/result')
const authenticationFace = () => import('./view/authentication/face')
const ActivityBand = () => import('./view/activities/band.vue')


// 小花中间界面
const SmallFlower = () => import('./view/middle/smallFlower.js')
// 微博中间界面
const WeiboMiddle = () => import('./view/middle/weiboMiddle.js')
// 小花资料补充界面
const SmallFlowerBase = () => import('./view/authentication/smallFlowerBase.vue')
// 落地页
const LandingIndex = () => import('./view/landing')

// 微信扫描下载
const WechatScanResult = () => import('./view/authentication/wechatScanResult.vue')
// 小花接入结果页
const FlowerResult = () => import('./view/authentication/flowerResult.vue')
// IRR24结果界面
const IRR24Result = () => import('./view/authentication/iRR24Result.vue')

// 未授信新人活动详情页 - 1.7.8.9
const UnauthedNewbieDetail = () => import('./view/activities/unauthed-newbie/index.vue')
// 未授信新人活动规则 - 1.7.8.9
const UnauthedNewbieRule = () => import('./view/activities/unauthed-newbie/rule.vue')
// tbs结果界面
const TbsMigration = () => import('./view/authentication/tbsMigration/index.vue')
// 补录OCR
const SupplementaryOCR = () => import('./view/authentication/supplementaryOCR')
// 临时给天美贷上架用的
// const ConcealProtocoltmd = () => import('./view/tmd/conceal')
const LoginProtocoltmd = () => import('./view/tmd/login')
const privacyProtocoltmd = () => import('./view/tmd/privacy')
const LoanProtocoltmd = () => import('./view/tmd/loan')

const withdrawIndex = () => import('./view/withdraw/index') // 提现首页
const withdrawMiddle = () => import('./view/withdraw/poor-credit.vue') // 提现中间页
const withdrawPreview = () => import('./view/withdraw/preview') // 提现预览
// const withdrawMiddleTwo = () => import('./view/withdraw/middle') // 提现完中间界面
const withdrawResult = () => import('./view/withdraw/result') // 提现结果
const withdrawProtocol = () => import('./view/withdraw/protocol') // 提现相关协议

const passCardWithDraw = () => import('./view/withdraw/passcard') // pass卡提现首页
const passCardWithDraw2 = () => import('./view/withdraw/passcard2') // pass卡提现首页
const passCardWithDrawResultClean = () => import('./view/withdraw/result-clean-passcard') // pass卡提现结果页
const upCardWithDrawResultClean = () => import('./view/withdraw/result-clean-up') // pass卡提现结果页

const xiaoMeiVIP = () => import('./view/withdraw/xiaoMeiVIP.vue') // 小美VIP优惠
// 权益卡落地页
const equityLanding = () => import('./view/landing/equity/index.vue')
// 账号与安全
const accountPage = () => import('./view/mine/account-security')
const bindWechat = () => import('./view/wechat/bind.vue')
const wechatBinded = () => import('./view/wechat/binded.vue')

const riskNoticePage = () => import('./view/mine/signout/risk-notice.vue')
const rishAuthNoticePage = () => import('./view/mine/signout/auth-notice.vue')
const signoutAuthPage = () => import('./view/mine/signout/auth.vue')
const cannotSignoutReasonPage = () => import('./view/mine/signout/reason.vue')
const signoutResultPage = () => import('./view/mine/signout/result.vue')
const bizLimitUpConfirmPage = () => import('./view/withdraw/biz-limit-up-confirm.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './view/home'),
      meta: { pageName: 'page_home' }
    },
    {
      path: '/find',
      name: 'pageFind',
      component: Find
    },
    {
      path: '/user/strategy',
      name: 'strategy',
      component: Strategy,
      meta: { pageName: 'page_strategy' }
    },
    {
      path: '/user/question',
      name: 'question',
      component: Question,
      meta: { pageName: 'page_question' }
    },
    {
      path: '/union-login',
      name: 'unionLogin',
      component: () => import('./view/user/union-login'),
      meta: { pageName: 'page_union_login' }
    },
    {
      path: '/user/login',
      name: 'login',
      component: Login,
      meta: { pageName: 'page_login_register' }
    },
    {
      path: '/user/login/validate',
      name: 'loginValidate',
      component: LoginValidate,
      meta: { pageName: 'page_login_code' }
    },
    {
      path: '/mine',
      name: 'mine',
      component: Mine,
      meta: { pageName: 'page_page_my' }
    },
    {
      path: '/repayment',
      name: 'repayment',
      component: Repayment,
      meta: { pageName: 'page_repayment', title: '我的借款' }
    },
    {
      path: '/repayment/consult',
      name: 'repaymentRonsult',
      component: () => import('./view/repayment/consult/tmd-confirm.vue'),
      meta: { pageName: 'page_repayment_consult' }
    },
    {
      path: '/repayment/consult/apply',
      name: 'repaymentConsultApply',
      component: () => import('./view/repayment/consult/apply.vue'),
      meta: { pageName: 'page_repayment_apply' }
    },
    {
      path: '/repayment/consult/preview',
      name: 'repaymentConsultPreview',
      component: () => import('./view/repayment/consult/preview.vue'),
      meta: { pageName: 'page_repayment_preview' }
    },
    {
      path: '/repayment/consult/result',
      name: 'repaymentConsultResult',
      component: () => import('./view/repayment/consult/result.vue'),
      meta: { pageName: 'page_repayment_consult_result' }
    },
    {
      path: '/protocol',
      name: 'relateProtocol',
      component: RelateProtocol,
      meta: { pageName: 'page_agreement_list', title: '相关协议' }
    },
    {
      path: '/protocol/bankcard-pay',
      name: 'bankcardPayProtocol',
      component: () => import('./view/protocol/bankcard-pay.vue')
    },
    {

      path: '/protocol/update',
      name: 'updateProtocol',
      component: UpdateProtocol,
      meta: { pageName: 'page_agreement_update' }
    },
    {
      path: '/protocol/login',
      name: 'loginProtocol',
      component: LoginProtocol,
      meta: { pageName: 'page_registration_service_agreement' }
    },
    {
      path: '/protocol/loan',
      name: 'loanContactProtocol',
      component: LoanContactProtocol
    },
    {
      path: '/protocol/loan-instruction',
      name: 'loanInstructionProtocol',
      component: InstructionLoanProtocol
    },
    {
      path: '/protocol/authorization',
      name: 'personalAuthorizationInfo',
      component: PersonalAuthorizationInfo
    },
    {
      path: '/protocol/loan-quota',
      name: 'personalLoanQuotaProtocol',
      component: () => import('./view/protocol/loan-quota.vue')
    },
    {
      path: '/protocol/privacy',
      name: 'privacyProtocol',
      component: PrivacyProtocol,
      meta: { pageName: 'page_privacy_agreement' }
    },
    {
      path: '/protocol/entrust',
      name: 'entrustProtocol',
      component: EntrustProtocol
    },
    {
      path: '/protocol/pdf',
      name: 'pdfProtocol',
      component: PdfProtocol,
      meta: { pageName: 'page_agreement_details' }
    },
    // 360要的pdf页面
    {
      path: '/protocol/pdf360',
      name: 'pdfProtocol360',
      component: () => import('@/view/protocol/pro360.vue'),
      meta: { pageName: 'page_agreement_details' }
    },
    
    
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: { pageName: 'page_page_about', title: '关于我们' }
    },
    {
      path: '/aboutqb',
      name: 'aboutqb',
      component: Aboutqb,
      meta: { pageName: 'page_page_aboutqb' }
    },
   
   
    {
      path: '/protocol/qb/login',
      name: 'protocolLoginqb',
      component: ProtoclLoginQB
    },
    {
      path: '/protocol/qb/privacy',
      name: 'protocolPrivacyqb',
      component: ProtoclPrivacyQB
    },

    // 提现
    {
      path: '/withdraw/index',
      component: withdrawIndex,
      name: 'withdrawIndex'
    },
    // 新的提现页面
    {
      path: '/withdraw/index2',
      component: () => import('@/view/withdraw/index-fake.vue'),
      name: 'withdrawIndex2'
    },
    {
      path: '/withdraw/poor-credit',
      component: withdrawMiddle,
      name: 'withdrawMiddle',
      meta: { pageName: 'page_withdrawmiddle' }
    },
    // {
    //   path: '/withdraw/middle',
    //   // component: withdrawMiddleTwo,
    //   redirect: '/middle/limit',
    //   name: 'withdrawMiddleTwo'
    //   // meta: { pageName: 'page_withdrawmiddle' }
    // },
    {
      path: '/withdraw/preview',
      component: withdrawPreview,
      name: 'withdrawPreview'
      // meta: { pageName: 'page_withdraw_preview' }
    },
    {
      path: '/withdraw/preview-next',
      component: () => import('@/view/withdraw/preview_next.vue'),
      name: 'withdrawPreviewNext'
    },
    // 新的提现预览页面
    {
      path: '/withdraw/preview2',
      component: () => import('@/view/withdraw/preview-fake.vue'),
      name: 'withdrawPreview2'
    },
    {
      path: '/withdraw/result',
      component: withdrawResult,
      name: 'withdrawResult'

    },
    // 清洁版提现结果
    {
      path: '/withdraw/result2',
      component: () => import('@/view/withdraw/result-clean.vue'),
      name: 'withdrawResultClean'

    },
    {
      path: '/withdraw/result3',
      component: passCardWithDrawResultClean,
      name: 'passCardResultClean'
    },
    {
      path: '/withdraw/result4',
      component: () => import('@/view/withdraw/result-virtually.vue'),
      name: 'passCardResultClean2'
    },
    {
      path: '/withdraw/result5',
      component: upCardWithDrawResultClean,
      name: 'upCardResultClean'
    },
    {
      path: '/withdraw/protocol',
      component: withdrawProtocol,
      name: 'withdrawProtocol',
      meta: { pageName: 'page_withdraw_protocols' }
    },
    {
      path: '/withdraw/xiaoMeiVIP',
      component: xiaoMeiVIP,
      name: 'xiaoMeiVIP',
      meta: { pageName: 'page_withdraw_xiaoMeiVIP' }
    },
    {
      path: '/withdraw/passcard',
      component: passCardWithDraw,
      name: 'passCardWithDraw',
      meta: { pageName: 'page_withdraw_passcard' }
    },
    {
      path: '/withdraw/passcard2',
      component: passCardWithDraw2,
      name: 'passCardWithDraw2',
      meta: { pageName: 'page_withdraw_passcard2' }
    },
    {
      path: '/withdraw/refused/pass',
      component: () => import('./view/withdraw/refuse-pass.vue'),
      name: 'refusedPass'
    },
    {
      path: '/middle/smallFlower',
      component: SmallFlower,
      name: 'smallFlower'
      // meta: { pageName: 'page_small_flower' }
    },
    {
      path: '/middle/weibo',
      component: WeiboMiddle,
      name: 'weiboMiddle'
      // meta: { pageName: 'page_small_flower' }
    },
    {
      path: '/repayment/history',
      component: LoanHistory,
      name: 'loanHistory',
      meta: { pageName: 'page_loan_history', title: '我的账单' }
    },
    {
      path: '/repayment/third',
      component: () => import('./view/repayment/third-repay.vue'),
      name: 'thirdRepay',
      meta: { pageName: 'page_tripartite_repayment' }
    },
    {
      path: '/repayment/tmd',
      component: TmdRepayment,
      name: 'tmdRepayment',
      meta: { pageName: 'page_repayment' }
    },
    {
      path: '/repayment/confirm',
      component: RepaymentConfirm,
      name: 'repaymentConfirm',
      meta: { pageName: 'page_repayment_confirmation_other', title: '确认还款' }
    },
    {
      path: '/repayment/confirm/tmd',
      component: TmdRepaymentConfirm,
      name: 'tmdRepaymentConfirm',
      meta: { pageName: 'page_repayment_confirmation' }
    },
    {
      path: '/repayment/overdue',
      component: TmdOverdueRepayment,
      name: 'tmdOverdueRepayment',
      meta: { pageName: 'page_repayment_overdue' }
    },
    {
      path: '/repayment/detail',
      name: 'repaymentDetail',
      component: RepaymentDetail,
      meta: { pageName: 'page_repayment_details', title: '借款详情' }
    },
    {
      path: '/repayment/detail-expense',
      name: 'repaymentDetailExpense',
      component: () => import('@/view/repayment/detail-expense.vue'),
      meta: { pageName: 'page_repayment_details_expense', title: '账单详情' }
    },
    {
      path: '/repayment/confirm-expense',
      name: 'repaymentConfirmExpense',
      component: () => import('@/view/repayment/confirm-expense.vue'),
      meta: { pageName: 'page_repayment_confirm_expense', title: '订单支付' }
    },
    {
      path: '/repayment/result',
      name: 'repaymentResult',
      component: RepaymentResult,
      meta: {
        pageName: ''
      }
    },
    {
      path: '/repayment/result-expense',
      name: 'repaymentResultExpense',
      component: () => import('@/view/repayment/result-expense.vue'),
      meta: {
        pageName: ''
      }
    },

    // {
    //     path: '/tmd/protocol/conceal',
    //     name: 'concealProtocoltmd',
    //     component: ConcealProtocoltmd,
    //     meta: { pageName: '' }
    // },
    {
      path: '/tmd/protocol/login',
      name: 'loginProtocoltmd',
      component: LoginProtocoltmd,
      meta: { pageName: '' }
    },
    {
      path: '/tmd/protocol/privacy',
      name: 'privacyProtocoltmd',
      component: privacyProtocoltmd,
      meta: { pageName: '' }
    },
    {
      path: '/tmd/protocol/loan',
      name: 'loanProtocoltmd',
      component: LoanProtocoltmd,
      meta: { pageName: '' }
    },
    {
      path: '/authentication/base',
      name: 'authenticationBase',
      component: AuthenticationBase,
      meta: { pageName: 'page_auth_baseinfo' }
    },
    {
      path: '/authentication/smallFlowerBase',
      name: 'smallFlowerBase',
      component: SmallFlowerBase,
      meta: { pageName: 'page_auth_smallFlowerBase' }
    },
    {
      path: '/authentication/id',
      name: 'authenticationId',
      component: AuthenticationId,
      meta: { pageName: 'page_auth_identity' }
    },
    {
      path: '/authentication/supplementaryOCR',
      name: 'supplementaryOCR',
      component: SupplementaryOCR,
      meta: { pageName: 'page_auth_supplementaryOCR' }
    },
    {
      path: '/authentication/face',
      component: authenticationFace,
      name: 'faceAuthentication',
      meta: { pageName: 'page_auth_faceid' }
    },
    {
      path: '/authentication/face-mp',
      component: () => import('./view/authentication/face-mp'),
      name: 'faceAuthenticationMp',
      meta: { pageName: 'page_auth_faceid_mp', title: '身份验证' }
    },
    {
      path: '/authentication/face-error',
      component: () => import('./view/authentication/faceError'),
      name: 'faceError',
      meta: { pageName: 'yzd_result' }
    },
    {
      path: '/authentication/id/guide',
      name: 'authenticationIdGuide',
      component: AuthenticationIdGuide,
      meta: { pageName: 'page_auth_identity_guide' }
    },
    {
      path: '/authentication/up/guide',
      name: 'AuthenticationUpGuide',
      component: AuthenticationUpGuide,
      meta: { pageName: 'path_auth_up_guide' }
    },
    // 授信等待页面
    {
      path: '/authentication/wait',
      name: 'authenticationWait',
      component: () => import('./view/authentication/wait.vue')
    },
    // 授信审核中页面
    {
      path: '/authentication/auditing',
      name: 'authenticationAuditing',
      component: () => import('./view/authentication/auditing-fake.vue')
    },
    // 清洁版授信结果页面
    {
      path: '/authentication/result2',
      name: 'authenticationResultClean',
      component: () => import('./view/authentication/result-clean.vue')
    },
    {
      path: '/tbs/migration/qy',
      name: 'tbsMigration',
      component: TbsMigration,
      meta: { pageName: 'page_tbs_migration' }
    },
    {
      path: '/authentication/result',
      name: 'authenticationResult',
      component: AuthenticationResult
    },
    {
      path: '/authentication/result-pass',
      name: 'authenticationResultPass',
      component: () => import('./view/authentication/auth-guide-pass.vue')
    },
    {
      path: '/authentication/result-mp', // 小程序结果页
      name: 'authenticationResultMiniProgram',
      component: () => import('./view/authentication/result-mp.vue'),
      meta: {
        title: '天美贷极速借'
      }
    },
    {
      path: '/landing/index',
      name: 'landingIndex',
      component: LandingIndex,
      meta: { pageName: 'page_landing_index' }
    },
     
    {
      path: '/wechatScan/result',
      name: 'wechatScanResult',
      component: WechatScanResult,
      meta: { pageName: 'wechat-scan-result' }
    },
    {
      path: '/flower/result/:base64',
      name: 'flowerResult',
      component: FlowerResult
      // meta: { pageName: 'page_flower-result' }
    },
    {
      path: '/iRR/result',
      name: 'iRR24Result',
      component: IRR24Result,
      meta: { pageName: 'result' }
    },
  
    {
      path: '/unauthedNewbie/detail',
      name: 'UnauthedNewbieDetail',
      component: UnauthedNewbieDetail
    },
    {
      path: '/unauthedNewbie/rule',
      name: 'UnauthedNewbieRule',
      component: UnauthedNewbieRule
    },
    /// 引流活动 end
    {
      path: '/landing/rejectpay/a',
      name: 'landingActivityA',
      component: () => import('./view/landing/rejectpay/a.vue'),
      meta: { pageName: 'page_active_landing_rejectpay_a' }
    },
    {
      path: '/landing/rejectpay/b',
      name: 'landingActivityB',
      component: () => import('./view/landing/rejectpay/b.vue'),
      meta: { pageName: 'page_active_landing_rejectpay' }
    },
    {
      path: '/landing/leading',
      name: 'landingLeading',
      component: () => import('./view/landing/leading.vue'),
      meta: { pageName: 'page_active_landing_leading' }
    },
    
    {
      path: '/activities/band',
      name: 'activityBand',
      component: ActivityBand,
      meta: { pageName: 'page_active_bankcard_rejectpay' }
    },
    // 新福利中心
    {
      path: '/newWelfare/index',
      name: 'newWelfareIndex',
      component: () => import('./view/mine/newWelfare/index.vue'),
      meta: { pageName: 'page_user_welfare_centre' }
    },
    // 新福利中心
    {
      path: '/noWelfare/index',
      name: 'noWelfareIndex',
      component: () => import('./view/mine/newWelfare/other.vue'),
      meta: { pageName: 'page_no_welfare_centre' }
    },
   
    // 新人专享活动

    // 福利中心
    {
      path: '/welfare/list',
      name: 'welfarelist',
      component: () => import('./view/mine/newWelfare/index.vue'),
      meta: { pageName: 'page_welfare_list' }
    },
    {
      path: '/welfare/history',
      name: 'welfareHistory',
      component: () => import('./view/welfare/history.vue'),
      meta: { pageName: 'page_welfare_history' }
    },

    // 飞贷协议

    {
      path: '/protocol/yzd/fd/service',
      component: () => import('./view/protocol/cef/service'),
      name: 'fdService'
    },
    {
      path: '/protocol/yzd/fd/cef-loan',
      component: () => import('./view/protocol/cef/cef-loan'),
      name: 'fdCefLoan'
    },
    {
      path: '/protocol/yzd/fd/loan',
      component: () => import('./view/protocol/cef/loan'),
      name: 'fdLoan'
    },
    {
      path: '/protocol/yzd/fd/entrust',
      component: () => import('./view/protocol/cef/entrust'),
      name: 'fdEntrust'
    },
    {
      path: '/protocol/yzd/fd/authorization',
      component: () => import('./view/protocol/cef/authorization'),
      name: 'fdAuthorization'
    },
    {
      path: '/protocol/yzd/fd/comprehensive-authorization', // 综合授权书
      component: () => import('./view/protocol/cef/comprehensive-authorization.vue'),
      name: 'fdComprehensiveAuthorization'
    },
    {
      path: '/landing/equity/index',
      name: 'landingEquity',
      component: equityLanding
    },
    { path: '/vip/orule',
      component: () => import('./view/vip/orule'),
      name: 'ruleOldVip',
      meta: { pageName: 'page_vip_orule' }
    },
    { path: '/vip/index',
      component: () => import('./view/vip/Index'),
      name: 'vip',
      meta: { pageName: 'page_vip' }
    },
    // { path: '/withdraw/ssvip',
    //   component: () => import('./view/withdraw/ssvip.vue'),
    //   name: 'sSvipWithdraw',
    //   meta: { pageName: 'page_withdraw_ssvip' }
    // },
    // { path: '/withdraw/compare',
    //   component: () => import('./view/withdraw/compare.old.vue'),
    //   name: 'compareWithdraw',
    //   meta: { pageName: 'page_withdraw_compare' }
    // },
    { path: '/withdraw/android/middle',
      component: () => import('./view/withdraw/android-middle'),
      name: 'compareAndroid',
      meta: { pageName: 'page_withdraw_android' }
    },
    { path: '/ssvip/result',
      component: () => import('./view/authentication/sSvipResult.vue'),
      name: 'sSvipResult',
      meta: { pageName: 's_svip_result' }
    },
    // { path: '/vip/preindex',
    //   component: () => import('./view/vip/preIndex'),
    //   name: 'preVip'
    //   //   meta: { pageName: 'page_pre_vip' }
    // },
    // 支付中间界面
    { path: '/vip/middle',
      component: () => import('./view/vip/middle'),
      name: 'vipMiddle'
    },
    {
      path: '/vip/rule', // vip规则
      component: () => import('./view/vip/rule'),
      name: 'vipRule',
      meta: { pageName: 'page_vip_rule' }
    },
    {
      path: '/weibo/protocol', // vip规则
      component: () => import('./view/middle/protocol.vue'),
      name: 'weiboProtocol',
      meta: { pageName: 'page_weibo_protocol' }
    },
    {
      path: '/weibo/login', // 微博登录协议
      component: () => import('./view/middle/login.vue'),
      name: 'weiboLogin',
      meta: { pageName: 'page_weibo_login' }
    },
    {
      path: '/weibo/privacy', // 微博隐私协议
      component: () => import('./view/middle/privacy.vue'),
      name: 'weiboPravite',
      meta: { pageName: 'page_weibo_privacy' }
    },
    // 小美vip落地页（1.7.4新增）
    {
      path: '/landing/vip/index',
      component: () => import('./view/landing/vip/index'),
      name: 'landingVip'
    },
    {
      path: '/landing/vip/svip', // ssvip界面
      component: () => import('./view/landing/vip/ssvip'),
      name: 'landingSSVip'
    },
    {
      path: '/landing/vip/svip/two', // ssvip界面2
      component: () => import('./view/landing/vip/ssvip2'),
      name: 'landingSSVipTwo'
    },
    {
      path: '/landing/svip/stock', // ssvip界面
      component: () => import('./view/landing/vip/stock.vue'),
      name: 'landingStock'
    },
    // 导流界面
    {
      path: '/river/diversion',
      component: () => import('./view/home/riverDiversion'),
      name: 'riverDiversion'
      // meta: { pageName: 'river_diversion_detail' }
    },
    // 导流主页2
    {
      path: '/river/diversion2',
      component: () => import('./view/home/riverDiversion/index2.vue'),
      name: 'riverDiversion2',
      meta: { pageName: 'river_diversion2' }
    },
    // 导流中间界面
    {
      path: '/river/middle',
      component: () => import('./view/home/riverDiversion/middle.vue'),
      name: 'riverMiddle'
      // meta: { pageName: 'page_river_middle' }
    },
    // 导流中间结果界面
    {
      path: '/river/result',
      component: () => import('./view/home/riverDiversion/result.vue'),
      name: 'riverResult',
      meta: { pageName: 'page_river_Result' }
    },
    // 导流协议
    {
      path: '/river/diversion/protocol',
      component: () => import('./view/home/riverDiversion/protocol.vue'),
      name: 'riverDiversionProtocol',
      meta: { pageName: 'river-diversion-protocol' }
    },
    // 导流落地页
    {
      path: '/landing/river',
      component: () => import('./view/landing/river/index.vue'),
      name: 'landingRiver',
      meta: { pageName: 'page_landing_river' }
    },
    // 导流下载中心页
    {
      path: '/landing/river/middle',
      component: () => import('./view/landing/river/middle.vue'),
      name: 'landingRiverMiddle'
    },
    // 催收催告函短链接
    {
      path: '/landing/collection/middle',
      component: () => import('./view/landing/collection/middle.vue'),
      name: 'landingCollection'
    },
    // 我要提现 未购买权益
    // {
    //   path: '/withdraw/svip/middle',
    //   name: 'withdrawSvipMiddle',
    //   component: () => import('./view/withdraw/middle/withdraw-svip-middle.vue')
    //   // meta: { pageName: 'page_withdraw_svip_middle' }
    // },
    // 秒杀活动
    {
      path: '/secKill/index',
      component: () => import('./view/activities/secKill'),
      name: 'secKill',
      meta: { pageName: 'page_sec_kill' }
    },
    // 秒杀活动规则界面
    {
      path: '/secKill/rule',
      component: () => import('./view/activities/secKill/rule.vue'),
      name: 'secKillRule',
      meta: { pageName: 'page_sec_kill_rule' }
    },
    // 中间界面跳转橡树
    {
      path: '/three/middle',
      component: () => import('./view/vip/three-middle'),
      name: 'threeMiddle',
      meta: { pageName: 'page_three_middle' }
    },
    // 跳转视频会员中间页面
    {
      path: '/video/middle',
      component: () => import('./view/vip/video-middle'),
      name: 'videoMiddle',
      meta: { pageName: 'page_video_middle' }
    },
    // 联系客服页面
    {
      path: '/service',
      component: () => import('./view/home/service'),
      name: 'service',
      meta: { pageName: 'page_service' }
    },
    {
      path: '/mine/account',
      component: accountPage,
      name: 'accountAndSecurity',
      meta: { pageName: 'account_security' }
    },
    {
      path: '/mine/protocol',
      component: () => import('@/view/mine/account-security/protocol.vue'),
      name: 'accountMineProtocol',
      meta: { pageName: 'accountMineProtocol' }
    },
    {
      path: '/mine/signout/risk-notice',
      component: riskNoticePage,
      name: 'signoutRiskNotice',
      meta: { pageName: 'page_signout_risk_notice' }
    },
    {
      path: '/mine/signout/auth',
      component: signoutAuthPage,
      name: 'signoutAuth',
      meta: { pageName: 'page_signout_auth' }
    },
    {
      path: '/mine/signout/reason',
      component: cannotSignoutReasonPage,
      name: 'cannotSignoutReason',
      meta: { pageName: 'page_cannot_signout_reason' }
    },
    {
      path: '/mine/signout/result',
      component: signoutResultPage,
      name: 'signoutResult',
      meta: { pageName: 'page_signout_result' }
    },
    {
      path: '/mine/signout/auth-notice',
      component: rishAuthNoticePage,
      name: 'signoutAuthNotice',
      meta: { pageName: 'page_signout_auth_notice' }
    },
    {
      path: '/user/wechat/bind',
      component: bindWechat,
      name: 'bindWechat',
      meta: { pageName: 'bind_wechat' }
    },
    {
      path: '/user/wechat/binded',
      component: wechatBinded,
      name: 'wechatBinded',
      meta: { pageName: 'wechat_binded' }
    },

    {
      path: '/authentication/pre-base',
      name: 'authenticationPreBase',
      component: () => import('./view/authentication/pre-base'),
      meta: { pageName: 'page_auth_baseinfo' }
    },
    {
      path: '/withdraw/upcard',
      name: 'withdrawUpCard',
      component: () => import('./view/withdraw/upcard'),
      meta: { pageName: 'page_withdraw_upcard' }
    },
    {
      path: '/withdraw/biz-limit-up-confirm',
      name: 'withdrawBizLimitUpConfirm',
      component: bizLimitUpConfirmPage,
      meta: { pageName: 'page_withdraw_biz_limit_up_confirm' }
    },
    ...api,
    ...middle,
    ...privilege,
    ...refund,
    ...protocol,
    ...landing,
    ...h5Credit,
    ...modifyUserInfo,
    ...bankCard,
    ...actives,
    ...vips,
    ...appSE,
    ...msg,
    ...coupon,
    ...quickRepay,
    ...feedback,
    // 所有的路由都要放在这个前面
    {
      path: '/404',
      component: () => import('@/view/404')
    },
    { path: '/:catchAll(.*)', redirect: '/404' }
  ],

  scrollBehavior (to, from, savedPosition) {
    // 滚动到顶部
    return { x: 0, y: 0 }
  }
})
function wxMiniProcess (to) {
  if (isTMDMiniprogram()) {
    let i = document.createElement('iframe')
    i.style.display = 'none'
    i.onload = function () {
      document.title = to?.meta?.title || '天美贷极速借'
      setTimeout(() => {
        i.remove()
      }, 300)
    }
    document.body.appendChild(i)
  }
}

const routers = {
  '/': 'BACK_HOME', // 首页
  '/user/login': 'JUMP_TO_LOGIN'// 登录页
}


router.beforeEach(async (to, from, next) => {
  const configIds = getKey('configIds')
  // 小程序中的H5页面设置标题
  wxMiniProcess(to)
  // 小程序中跑到H5的部分页面需要拦截
  if (isTMDMiniprogram() && routers[to.path]) {
    wx.miniProgram.postMessage({ data: { eventType: routers[to.path], eventId: '', url: '', value: null } })
    wx.miniProgram.navigateBack()
    return
  }
  if (to.path && window.$sensors) {
    window.$sensors.registerPage({
      router_path: to.path
    })
  }
  if (configIds && configIds.length) {
    window.$sensors.registerPage({
      product_code: JSON.stringify(configIds)
    })
  }
  const query = to.query
  const { onceToken, token } = query
  if (onceToken) {
    await unionLogin(query)
  }
  if (token) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    const obj = { ...userInfo, token }
    localStorage.setItem('userInfo', JSON.stringify(obj))
    await store.dispatch('user/getUserInfoX', { forceUpdate: true })
  }
  next()
})
export default router